import "./Footer.scss";

import { useTranslation } from "react-i18next";

import GridBackground from "../GridBackground/GridBackground";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="siteFooter">
      <GridBackground />
      <div className="footerContent">
        <div className="footerCopy">{t("footer.copyright")}</div>
        <div className="footerTag">
          {t("footer.tagline_prefix")}{" "}
          <span>{t("footer.tagline_highlight")}</span>
          {t("footer.tagline_suffix")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
